import qs from "qs"

export const filterEmptyValues = (obj: any): any => {
  if (obj === null || obj === undefined) return undefined

  if (typeof obj === "string") {
    return obj.trim() === "" ? undefined : obj
  }

  if (Array.isArray(obj)) {
    const filtered = obj.map(filterEmptyValues).filter(item => item !== undefined)
    return filtered.length === 0 ? undefined : filtered
  }

  if (typeof obj === "object") {
    const filtered: any = {}
    for (const [key, value] of Object.entries(obj)) {
      const filteredValue = filterEmptyValues(value)
      if (filteredValue !== undefined) {
        filtered[key] = filteredValue
      }
    }
    return Object.keys(filtered).length === 0 ? undefined : filtered
  }

  return obj
}

export const buildUrlWithQuery = (url: string, params: any) => {
  return `${url}?${qs.stringify(filterEmptyValues(params), { encodeValuesOnly: true })}`
}
